import normalize from './normalize'
import base from './base'
import button from './button'
import form from './form'
import link from './link'
import list from './list'
import spacing from './spacing'
import table from './table'
import typography from './typography'
import image from './image'
import rcSlider from './rcSlider'

export default {
  '@global': {
    ...normalize,
    ...base,
    ...button,
    ...form,
    ...link,
    ...list,
    ...spacing,
    ...table,
    ...typography,
    ...image,
    ...rcSlider
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/index.js